export default "__VITE_ASSET__Cxs40LZm__"